export enum ClientRestrictionStatus {
    None = 0,
    Blocked = 1,
    WhiteListed = 2,
    Captcha = 3
}
